export default function TheWall() {
  return (
    <section className="access-section bg-room-2 border-y border-soft">
      <span className="gold-rule-v" aria-hidden />
      <div className="access-container max-w-3xl">
        <span className="mono-label mono-label-gold">The real bottleneck</span>
        <h2 className="h-section mt-6">
          You think you need more knowledge. <span>You don't.</span> You need reps and a room.
        </h2>
        <div className="mt-12 space-y-7 body-lg">
          <p>Every guy who fails at remote sales fails for the same reason. He thinks the problem is information. So he buys another course. He watches another playlist. He saves another swipe file.</p>
          <p className="text-bone">And he still can't close.</p>
          <p>The truth is uglier. The thing standing between you and real money is not what you know. It's that you've never drilled the reps, you've never had your frame corrected by someone who's done it, and you've never been in a room where the standard is moving every day.</p>
          <p>You can study closing for a year and still freeze on a real call. You can run a month of real reps with correction and close.</p>
          <p className="text-bone font-display italic text-xl" style={{ fontVariationSettings: '"opsz" 96, "SOFT" 80', fontWeight: 350 }}>The Gate Method exists because of that gap.</p>
        </div>
      </div>
    </section>
  );
}
